export enum DirectionTabsEnum {
  prev = 'prev',
  next = 'next',
}
